module.exports = __webpack_public_path__ + "static/media/floating-btn.699e3b1a.png";